import { DATA_HOOKS } from '../dataHooks';
import { scroller } from 'react-scroll';
import { ConsumerSource } from '../types';
var WIDGET_HEADER_HEIGHT = 36;
var getAgentToolbarHeight = function () {
    var _a;
    return ((_a = document === null || document === void 0 ? void 0 : document.querySelector('.user-toolbar-expansion')) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
};
var getHeaderHeight = function () {
    var _a;
    return ((_a = document === null || document === void 0 ? void 0 : document.querySelector("div[data-hook=\"".concat(DATA_HOOKS.HEADER, "\"]"))) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
};
export var getTopOffsetForScrollToArticlePage = function () {
    return getAgentToolbarHeight() + getHeaderHeight();
};
export var scrollToHash = function (stepId, consumerType, containerRef) {
    var step = document.getElementById(stepId);
    var initialOffsetTop = (step === null || step === void 0 ? void 0 : step.offsetTop) || 0;
    if (step && containerRef && consumerType === ConsumerSource.WIDGET) {
        containerRef.current.scrollTo({
            top: step.offsetTop + WIDGET_HEADER_HEIGHT + 10,
            behavior: 'smooth'
        });
    }
    else if (step && containerRef && consumerType === ConsumerSource.HELP_CENTER) {
        scroller.scrollTo(stepId, {
            duration: 700,
            offset: -5,
            containerId: 'article-content-container',
            smooth: true,
        });
    }
    else if (step && consumerType === ConsumerSource.HELP_CENTER) {
        scroller.scrollTo(stepId, {
            duration: 700,
            offset: -getTopOffsetForScrollToArticlePage(),
            smooth: true,
        });
    }
    if (step && consumerType === ConsumerSource.HELP_CENTER) {
        setTimeout(function () {
            var currentOffsetTop = (step === null || step === void 0 ? void 0 : step.offsetTop) || 0;
            if (currentOffsetTop > initialOffsetTop) {
                if (containerRef) {
                    scroller.scrollTo(stepId, {
                        duration: 10,
                        offset: -5,
                        containerId: 'article-content-container',
                        smooth: true,
                    });
                }
                else {
                    scroller.scrollTo(stepId, {
                        duration: 10,
                        offset: -getTopOffsetForScrollToArticlePage(),
                        smooth: true,
                    });
                }
            }
        }, 690);
    }
    var tabs = new URLSearchParams(window.location.search).get('tabs');
    history.pushState(null, '', "".concat(location.pathname).concat(tabs ? "?tabs=".concat(tabs) : '', "#").concat(stepId));
};
//# sourceMappingURL=scroll.js.map